/* eslint-disable react/display-name */
import * as React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { DeleteRecordModal } from "./DeleteRecordModal";
import { formatDate } from "../../../../../../utils/DateFormat";
import { BalanceType, Statements, StatementStatus } from "../../../../../../store/Statements/Types";
import { UserInfo, UserRoles } from "../../../../../../store/AppTypes";
import { Currency } from "@vwpfs/mary-air-lib/components/air/05-atoms/CurrencyDisplay";
import { Modal } from "@vwpfs/mary-air-lib/components/air/06-molecules/Modal";
import { Pagination } from "@vwpfs/mary-air-lib/components/air/06-molecules/Pagination";
import { DispatchFunc } from "../../../../../../store/ActionTypes";
import { ReduxState } from "../../../../../../store/ReduxState";
import { remoteTrigger } from "../../../../../../store/RemoteActions";
import { RemoteScope } from "../../../../../../store/RemoteTypes";
import { ThemeSize, ThemePalette, ThemeShadowSizes, ThemeBreakpoints } from "@vwpfs/mary-air-lib/theme/_Types";
import { modalShow } from "../../../../../../utils/redux/ActionTypes";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { RowData, Table, TableData } from "@vwpfs/mary-air-lib/components/air/06-molecules/Table";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Badge } from "@vwpfs/mary-air-lib/components/air/05-atoms/Badge";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
import { getStatementStatusColor } from "../../../../../utils/FormatHelpers";
/**
 *
 */
interface OwnProps {
    results: Statements;
    accountId: string;
    asAuditTab?: boolean;
}
/**
 *
 */
interface StateProps {
    user?: UserInfo;
}
/**
 *
 */
interface DispatchProps {
    loadResults: (skip: number) => void;
    openDeleteRequest: (statementId: string) => void;
}
/**
 *
 */
type Props = OwnProps & DispatchProps & StateProps;
export const DeleteStatementModal = (id: string) => (
    () => (
        <Modal
            modalID={id}
            theme={{ size: ThemeSize.SMALL }}
        >
            <DeleteRecordModal
                modalID={id}
                statementId={id}
            />
        </Modal>
    )
);
/**
 *
 */
export const mapStateToProps = (s: ReduxState): StateProps => ({
    user: s.prop("user").isPresent() ? s.prop("user").get() : undefined,
});
/**
 *
 */
export const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    loadResults: (skip: number) => dispatch(remoteTrigger(RemoteScope.STATEMENT_RESULTS, {
        skip: skip,
    })),
    openDeleteRequest: (statementId: string) => dispatch(
        modalShow(
            statementId,
            DeleteStatementModal(statementId),
        ),
    ),
});
/**
 *
 */
export class ResultsComp
    extends React.Component<Props, {}> {
    public constructor(props: Props) {
        super(props);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.getProcessedRows = this.getProcessedRows.bind(this);
        this.openDelete = this.openDelete.bind(this);
        this.resultsData = this.resultsData.bind(this);
    }
    /**
     *
     */
    public render() {
        return (
            <React.Fragment>
                <Table
                    hasActions
                    data={{
                        columns: this.resultsData().columns,
                        rows: this.resultsData().rows,
                        sort: this.resultsData().sort,
                    }}
                />
                {(this.props.results?.totalPages && this.props.results?.totalPages > 1) ?
                    <Container
                        className="scl-h-text-align--center"
                        theme={{
                            padding: { "": { t: 3, b: 2 }, "sm": { t: 4, b: 3 } },
                        }}
                    >
                        <Pagination
                            pageCount={this.props.results.totalPages}
                            currentPage={this.props.results.number}
                            onPageChange={this.handlePageClick}
                            theme={{ palette: ThemePalette.CONTRAST_PRIMARY }}
                        />
                    </Container> : null}
            </React.Fragment>
        );
    }
    private handlePageClick(skip: number) {
        this.props.loadResults(skip);
    }
    /**
     *
     */
    private getProcessedRows(): RowData[] {
        return this.props.results.content.map((row, index) => {
            const balanceOPBD = row.balances.find(balance => balance.balanceTypeCode === BalanceType.OPENINGBALANCE);
            const balanceCLBD = row.balances.find(balance => balance.balanceTypeCode === BalanceType.CLOSINGBALANCE);
            return ({
                id: row.id,
                data: [
                    row.stmtId,
                    (
                        <span key={`creation-date${index}`}>
                            {formatDate(new Date(row.creationDateTime), "DD-MM-YYYY")}
                        </span>
                    ),
                    row.mutationDate ?
                        (
                            <span key={`mutation-date${index}`}>
                                {formatDate(new Date(row.mutationDate), "DD-MM-YYYY")}
                            </span>
                        ) : "",
                    (
                        <Badge
                            key={`badge${index}`}
                            theme={{ paletteState: getStatementStatusColor(row.statementStatus) }}>
                            {row.statementStatus ? row.statementStatus.toString() : "n.a."}
                        </Badge>
                    ),
                    balanceOPBD ? <h6><Currency value={balanceOPBD.amount.amount} /></h6> : "",
                    balanceCLBD ? <h6><Currency value={balanceCLBD.amount.amount} /></h6> : "",
                    <ButtonsWrapper
                        key={`navlink-${index}`}
                        asGroup
                        alignment={Alignment.RIGHT}
                        defaultOrientation={Orientation.HORIZONTAL}
                        orientations={{
                            [ThemeBreakpoints.XS]: Orientation.VERTICAL,
                            [ThemeBreakpoints.MD]: Orientation.HORIZONTAL,
                        }}
                    > {
                            this.props.asAuditTab ? (
                                    <NavLink to={`/audit/statements/${row.id}`}>
                                        <Button
                                            icon={IconNames.ARROW_RIGHT}
                                            theme={{
                                                palette: ThemePalette.CONTRAST_PRIMARY,
                                                shadow: ThemeShadowSizes.TINY,
                                            }}
                                        />
                                    </NavLink>
                            ) :
                                (
                                    <>
                                        {row.statementStatus === StatementStatus.UNPROCESSED &&
                                this.props.user?.userRole !== UserRoles.EW_DEBTOR &&
                                this.props.user?.userRole !== UserRoles.EW_ADMIN_READONLY &&
                                <Button
                                    icon={IconNames.DELETE}
                                    theme={{
                                        palette: ThemePalette.CONTRAST_PRIMARY,
                                        shadow: ThemeShadowSizes.TINY,
                                    }}
                                    link={{ onClick: this.openDelete(row.id.toString()) }}
                                />}
                                        <NavLink to={`/accounts/${this.props.accountId}/${row.id}`} exact>
                                            <Button
                                                icon={IconNames.ARROW_RIGHT}
                                                theme={{
                                                    palette: ThemePalette.CONTRAST_PRIMARY,
                                                    shadow: ThemeShadowSizes.TINY,
                                                }}
                                            />
                                        </NavLink>
                                    </>
                                )}</ButtonsWrapper>,
                ],
            });
        });
    }
    private openDelete(id: string) {
        return () => this.props.openDeleteRequest(id);
    }
    /**
     *
     */
    private resultsData(): TableData {
        return {
            sort: undefined,
            columns: [
                {
                    label: "Statement ID",
                },
                {
                    label: "Creation date",
                },
                {
                    label: "Mutation date",
                },
                {
                    label: "Status",
                },
                {
                    label: "Opening Balance",
                },
                {
                    label: "Closing Balance",
                    alignRight: true,
                },
                {
                    label: "Actions",
                },
            ],
            rows: this.getProcessedRows(),
        };
    }
}
/**
 *
 */
export const Results = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ResultsComp);
